import {Component, Input} from '@angular/core';

@Component({
  selector: 'ngbd-modal-customclass',
  templateUrl: './modal-customclass.html',
  styles: [``]
})
export class NgbdModalCustomclass {
  @Input() Title: string;
  @Input() Content: string;
  @Input() CloseButtonLabel: string;
  @Input() CallID: string;
  
  closeResult: string;

  constructor() {}


}


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/modals/Custom_Modal.ts